import useStore from "../../../../store"
import { useState } from "react"
import { Box, Field, Textarea } from '@chakra-ui/react'
import { HappyButton, NeutralButton } from "../../../common/Buttons"
import Spinner from "../../../common/Spinner"
import { typeEnum, purposeEnum, responseEnum } from "../../../../constants/touchEnums"
import SelectDropdown from '../../../common/SelectDropdown'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { colors } from "../../../../utilities/colors"

export default function TouchForm({ dealerId, setShowTouchForm }) {
  const createTouch = useStore((state) => state.createTouch)
  const isCreatingTouch = useStore((state) => state.isCreatingTouch)
  const user = useStore((state) => state.user)
  const setErrMessage = useStore((state) => state.setErrMessage)

  const [inputValues, setInputValues] = useState({
    type: null,
    purpose: null,
    response: null,
    note: null,
    follow_up_on: null,
    reminder: null,
    reminder_for_id: user.userId,
  })
  const [formErrors, setFormErrors] = useState([])

  const handleSubmit = async () => {
    if (!inputValues.type || !inputValues.purpose) {
      setErrMessage('Type and Purpose cannot be blank')
      setFormErrors(Object.keys(inputValues).filter((key) =>
        (key === 'type' || key === 'purpose') && !inputValues[key]
      ))
    } else {
      await createTouch(dealerId, inputValues)
      setShowTouchForm(false)
    }
  }

  return(
      <Box as="form" mt={2} ml={4} onSubmit={handleSubmit}>
        <Field.Root id="type" mb={2} onClick={() => setFormErrors([])}>
          <SelectDropdown
            label="Type of Touch"
            options={Object.keys(typeEnum)}
            defaultText={'Select type'}
            selectedItem={inputValues.type}
            setSelectedItem={(item) => setInputValues({ ...inputValues, type: item })}
            displaySelectedItem={(item) => typeEnum[item]}
            isErrored={formErrors.includes('type')}
            testId="type-select"
          />
        </Field.Root>
        <Field.Root id="purpose" mb={2} onClick={() => setFormErrors([])}>
          <SelectDropdown
            label="Purpose of Touch"
            options={Object.keys(purposeEnum)}
            defaultText={'Select purpose'}
            selectedItem={inputValues.purpose}
            setSelectedItem={(item) => setInputValues({ ...inputValues, purpose: item })}
            displaySelectedItem={(item) => purposeEnum[item]}
            isErrored={formErrors.includes('purpose')}
            testId="purpose-select"
          />
        </Field.Root>
        <Field.Root id="response" mb={2}>
          <SelectDropdown
            label="Response"
            options={Object.keys(responseEnum)}
            defaultText={'Select response'}
            selectedItem={inputValues.response}
            setSelectedItem={(item) => setInputValues({ ...inputValues, response: item })}
            displaySelectedItem={(item) => responseEnum[item]}
            isErrored={false}
            testId="response-select"
          />
        </Field.Root>
        <Field.Root id="note" mb={2}>
          <Field.Label fontSize={'sm'} color={colors.grey300} htmlFor="note">Note</Field.Label>
          <Textarea
            id="note"
            value={inputValues.note}
            onChange={(e) => setInputValues({ ...inputValues, note: e.target.value })}
            focusBorderColor="white"
            p={1}
            bgColor={colors.grey900}
            _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
          />
        </Field.Root>
        <Field.Root id="follow up on" mb={2} className="flex flex-col">
          <Field.Label fontSize={'sm'} color={colors.grey300} htmlFor="follow up on">Remind me on...</Field.Label>
          <DatePicker
            id="follow up on"
            selected={inputValues.follow_up_on}
            onChange={(date) => setInputValues({ ...inputValues, follow_up_on: date })}
            dateFormat="M/d/yy"
            className="px-1 py-0 w-full bg-grey-900 border-2 border-grey-700 focus:border-grey-300 focus:ring-0 rounded"
            showPopperArrow={false}
          />
        </Field.Root>
        <Field.Root id="reminder" mb={2}>
          <Field.Label fontSize={'sm'} color={colors.grey300} htmlFor="reminder">Remind me to...</Field.Label>
          <Textarea
            id="reminder"
            value={inputValues.reminder}
            onChange={(e) => setInputValues({ ...inputValues, reminder: e.target.value })}
            focusBorderColor="white"
            p={1}
            bgColor={colors.grey900}
            _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
          />
        </Field.Root>
        <div className="flex justify-evenly items-center">
          {isCreatingTouch ?
            <Spinner color="green" /> :
            <>
              <HappyButton
                text='Create Touch'
                onClick={handleSubmit}
                style="my-4 w-30 justify-items-center"
              />
              <NeutralButton
                text='Cancel'
                onClick={() => setShowTouchForm(false)}
                style="my-4 w-30 justify-items-center"
              />
            </>
          }
        </div>
      </Box>
  )
}